import React from "react";
import ModalStatus from "@/user/components/fair/modal_status";
import { createRoot } from "react-dom/client";

const fairModal = document.getElementById("js-fair-modal");
if (fairModal) {
  const fairModalRoot = createRoot(fairModal);
  const startOfMonth = fairModal.dataset.start_month;
  const webReservePeriodDate = fairModal.dataset.web_reserve_period;
  const isCustomFrom = fairModal.dataset.is_custom_form;
  const { holidays } = fairModal.dataset;

  if (!isCustomFrom) {
    fairModalRoot.render(null);
  } else {
    fairModalRoot.render(
      <>
        <ModalStatus
          webReservePeriodDate={webReservePeriodDate}
          startOfMonth={startOfMonth}
          holidays={JSON.parse(holidays)}
        />
      </>,
    );
  }
}
